import type { PagedQuery, PagedResult } from '@grc/ui-package';
import type { TenantDetails } from './tenant-types';

/** Paged, filtered and sorted tenant list (AB#7601). Replaces the unpaged GET /tenant. */
export const tenantsPagedUrl = '/v2/tenant';

/**
 * Turns the grid's request into GET /v2/tenant query parameters. The Active column is a set
 * filter; the API takes a single active=true|false, so anything but exactly one choice means both.
 */
export function toTenantQueryParams(query: PagedQuery): URLSearchParams {
  const params = new URLSearchParams();
  params.append('page', String(query.page));
  params.append('pageSize', String(query.pageSize));
  if (query.sort) params.append('sort', query.sort);

  Object.entries(query.filters).forEach(([key, value]) => {
    const values = Array.isArray(value) ? value : [value];
    if (key === 'active') {
      if (values.length === 1) params.append(key, values[0]);
      return;
    }
    values.forEach(v => params.append(key, v));
  });
  return params;
}

type GetPage = (url: string, params: URLSearchParams) => Promise<{ data: PagedResult<TenantDetails> }>;

/** Loads one grid page. A failed call rejects, which GrcGrid hands to onError. */
export async function fetchTenantPage(get: GetPage, query: PagedQuery): Promise<PagedResult<TenantDetails>> {
  const response = await get(tenantsPagedUrl, toTenantQueryParams(query));
  return {
    items: response.data?.items ?? [],
    totalItemCount: response.data?.totalItemCount ?? 0
  };
}
